var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "css-grid-display",
      style: [_vm.displayGridGap, _vm.displayModifierWidth],
    },
    _vm._l(_vm.rows, function (row, index) {
      return _c(
        "div",
        { key: index, staticClass: "css-grid-row" },
        _vm._l(row, function (gridItem, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass: "grid-item",
              style: `--ratio: ${gridItem.ratio};`,
            },
            [
              _c(
                "grid-item-content",
                { attrs: { content: gridItem.content } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "background-container",
                      attrs: { slot: "background" },
                      slot: "background",
                    },
                    [
                      _c("standard-image-display-attribution", {
                        attrs: {
                          "overlay-attribution": "",
                          "file-store": gridItem.image.fileStore,
                          aspect: gridItem.image.aspect,
                          "author-url": gridItem.image.attribution.authorUrl,
                          "author-name": gridItem.image.attribution.authorName,
                          "author-description":
                            gridItem.image.attribution.authorDescription,
                          "image-tint-strength": parseInt(gridItem.image.tint),
                        },
                      }),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        }),
        0
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }